const statusTranslate = (value) => {
  const status = parseInt(value, 10)
  switch (status) {
    case 1:
      return '<span class="badge badge-success">Ativo</span>'
    case 0:
      return '<span class="badge badge-danger">Inativo</span>'
    default:
      return '<span class="badge badge-secondary">Indefinido</span>'
  }
}

const typeStickTranslate = (value) => {
  switch (value) {
    case 'Sempre':
      return `<span title="${value}" class=""><i class="fas fa-sticky-note fa-2x"></i></span>`
    default:
      return `<span  title="${value}" class=""><i class="far fa-sticky-note fa-2x"></i></span>`
  }
}

const customerLabelTranslate = (value) => {
  switch (value) {
    case 'Aguardando Avaliação':
      return `<span title="${value}" class="badge bg-warning text-white">${value}</span>`
    case 'Avaliado':
      return `<span title="${value}" class="badge bg-success text-white">${value}</span>`
    case 'Invalidado':
      return `<span title="${value}" class="badge bg-secondary text-white">${value}</span>`
    case 'Excluído':
      return `<span title="${value}" class="badge bg-danger text-white">${value}</span>`
    default:
      return `<span title="Indefinido" class="badge bg-dark text-white">Indefinido</span>`
  }
}
const customerClassLabelTranslate = (value) => {
  switch (value) {
    case 'Titular':
      return `<span title="${value}" class="badge bg-primary text-white">${value}</span>`
    case 'Suplente':
      return `<span title="${value}" class="badge bg-pink text-white">${value}</span>`
    case 'Manual':
      return `<span title="${value}" class="badge bg-yellow">${value}</span>`
    default:
      return `<span title="Indefinido" class="badge bg-dark text-white">Indefinido</span>`
  }
}

const satisfactionLabelTranslate = (value) => {
  let hexColor = '#000000'

  switch (value) {
    case 0:
      hexColor = '#b72025'
      break
    case 1:
      hexColor = '#d62027'
      break
    case 2:
      hexColor = '#f05223'
      break
    case 3:
      hexColor = '#f36f21'
      break
    case 4:
      hexColor = '#faa823'
      break
    case 5:
      hexColor = '#ffca27'
      break
    case 6:
      hexColor = '#ecdb12'
      break
    case 7:
      hexColor = '#e8e73d'
      break
    case 8:
      hexColor = '#c5d92d'
      break
    case 9:
      hexColor = '#afd136'
      break
    case 10:
      hexColor = '#64b64d'
      break
    default:
      return '<u>Não respondeu</u>'
  }
  return `<button type="button" class="btn btn-icon rounded-pill" style="color: #fff; background-color: ${hexColor}; border-color: ${hexColor};">${value}</button>`
}

const enchantmentLabelTranslate = (value) => {
  switch (value) {
    case 0:
      return `<span title="Pior do que você esperava" class="badge bg-danger text-white">Pior do que você esperava</span>`
    case 1:
      return `<span title="Do jeito que você esperava" class="badge bg-yellow">Do jeito que você esperava</span>`
    case 2:
      return `<span title="Melhor do que você esperava" class="badge bg-success">Melhor do que você esperava</span>`
    default:
      return `<span title="Não Respondido" class="badge bg-dark text-white">Não Respondido</span>`
  }
}

const questionSatisfactionTranslate = (value) => {
  switch (value) {
    case 1:
      return 'De 0 a 10, qual a chance de recomendar a SN Britas para família, amigos, outra empresa e clientes?'
    case 2:
      return 'De 0 a 10, qual a chance de recomendar a SN Concreto para família, amigos, outra empresa e clientes?'
    case 3:
      return 'De 0 a 10, qual a chance de recomendar a SN Calcário para outra empresa ou cliente?'
    case 4:
      return 'De 0 a 10, qual a chance de recomendar a Vitória Minerais para outra empresa ou cliente?'
    case 5:
      return 'De 0 a 10, qual a chance de recomendar a SN Construtora para outra pessoa ou empresa?'
    default:
      return `<span title="Não Encontrado">Não Encontrado</span>`
  }
}
const questionEnchantmentTranslate = (value) => {
  switch (value) {
    case 1:
      return 'Em relação a sua última experiência como cliente da SN Britas, você diria que foi:'
    case 2:
      return 'Em relação a sua última experiência como cliente da SN Concreto, você diria que foi:'
    case 3:
      return 'Em relação a sua última experiência como cliente da SN Calcário, você diria que foi:'
    case 4:
      return 'Em relação a sua última experiência como cliente da Vitória Minerais, você diria que foi:'
    case 5:
      return 'Em relação a sua última experiência como cliente da SN Construtora, você diria que foi:'
    default:
      return `<span title="Não Encontrado">Não Encontrado</span>`
  }
}

// eslint-disable-next-line import/prefer-default-export
export {
  statusTranslate,
  typeStickTranslate,
  customerLabelTranslate,
  customerClassLabelTranslate,
  satisfactionLabelTranslate,
  enchantmentLabelTranslate,
  questionSatisfactionTranslate,
  questionEnchantmentTranslate,
}
